import React, { useEffect, useState } from "react";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser'
export const VideoHome = () => {


  const [info, setInfo] = useState([]);

  useEffect(() => {
      fetch("/config_generales")
          .then(res => res.json())
          .then(result => {
              setInfo(result);
          });
  }, []);

  if (info.video == null) {
    return false;
  }

    return (
        <div className="videoHome bg-gray">
            <div className="videoHome--container">
                <h1 className="title30">¿QUE ES JEEP PLAN?</h1>
                <div className="videoHome--container--video embed-responsive embed-responsive-21by9">
                  {ReactHtmlParser(info.video)}
                </div>
            </div>
        </div>
    )

}
